import { render, staticRenderFns } from "./bottomGoodsAction.vue?vue&type=template&id=45417e46&scoped=true"
import script from "./bottomGoodsAction.vue?vue&type=script&lang=js"
export * from "./bottomGoodsAction.vue?vue&type=script&lang=js"
import style0 from "./bottomGoodsAction.vue?vue&type=style&index=0&id=45417e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45417e46",
  null
  
)

export default component.exports